const BaseURL = 'https://lalp.melian.me/api';
export { 
  BaseURL,
}

